import _Vue from "vue";

export class CacheProvider {
    private saveCash<T>(key: string, obj: T, lifetimeSeconds: number) {
        const secondsNow = new Date().getTime();
        const data = {expired: secondsNow + lifetimeSeconds*1000, data: obj};
        localStorage.setItem(key, JSON.stringify(data));
    }
    private clearCash(key: string) {
        localStorage.removeItem(key);
    }
    private getCash<T>(key: string): T {
        const data = localStorage.getItem(key);
        if (!data) {
            return null;
        }
        const obj = JSON.parse(data) as {expired: number, data: T};
        const date = new Date();
        if (obj.expired < date.getTime()) {
            this.clearCash(key);
            return null;
        }
        return obj.data;
    }
    async getLanguagesAsync(): Promise<string[]> {
        const key = 'cached_languages';
        return new Promise<string[]>(async (resolve, reject) => {
            const cashed = this.getCash<string[]>(key);
            if (cashed) {
                resolve(cashed);
                return;
            }
            const res = await _Vue.$api.LanguageService.getLanguagesAsync();
            this.saveCash(key, res, 60*60);
            resolve((res || []).map(x=>x.toString()));
        })
    }
}


export default {
     install(Vue: typeof _Vue) {  
        const provider = new CacheProvider();
        Vue.prototype.$cacheProvider = provider;
        (Vue as any).$cacheProvider = provider;
    }
}